import React from 'react';
import OverNLBADetailLayout from '../components/OverNLBADetailLayout';
import banner from '../assets/business-parter-bg-1.jpg';
import waarom from '../assets/waarom kies je voor ons.jpeg';
import './OverNLBA.css';

const OverNLBAWaarom = () => {
  return (
    <OverNLBADetailLayout
      title="Waarom kies je voor ons"
      subtitle="Persoonlijk, praktijkgericht en ontwikkeld voor werkende professionals."
      heroImage={banner}
      heroAlt="Waarom kiezen voor NLBA"
    >
      <img src={waarom} alt="Waarom kiezen voor NLBA" className="over-nlba-waarom-image" />
    </OverNLBADetailLayout>
  );
};

export default OverNLBAWaarom;
